import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.notCompletedSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.notCompletedSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.notCompletedSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.notCompletedSettings.toggle.enable',
    }),
  }))

  return api
}
